import { useSyncExternalStore } from "react";

// v1.3 spec §B.1: open/closed state for the Pro Setup Flow celebration modal.
// Mirrors the kin_kids_crew_skipped localStorage pattern (Index.tsx) — a
// plain persisted flag checked once before opening, set on full-skip or on
// completing the flow. Modeled as a useSyncExternalStore module store (same
// shape as entitlementFlip.ts's entitlementOverride) so fireEntitlementFlipped
// can open the modal from outside React without prop-drilling.

export const SETUP_DONE_KEY = "kin_pro_memory_setup_done";

export function isProSetupDone(): boolean {
  try {
    return localStorage.getItem(SETUP_DONE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markProSetupDone(): void {
  try {
    localStorage.setItem(SETUP_DONE_KEY, "1");
  } catch {
    /* ignore */
  }
}

/** Admin testing convenience (Settings "Replay Pro setup") — clears the
 * done flag so openProWelcome() will open the modal again on next call. */
export function clearProSetupDone(): void {
  try {
    localStorage.removeItem(SETUP_DONE_KEY);
  } catch {
    /* ignore */
  }
}

let isOpen = false;
const listeners = new Set<() => void>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): boolean => isOpen;

export const useProSetupFlowOpen = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);

export function openProSetupFlow(): void {
  isOpen = true;
  notify();
}

export function closeProSetupFlow(): void {
  isOpen = false;
  notify();
}
